export const defaultCoordinates = { mapCenter: [0, 40.9098], zoomLevel: 2 };
